'use client';

import { Feature16 } from '@/components/feature16';
import { Feature51 } from '@/components/feature51';
import Footer from '@/components/footer';
import Hero from '@/components/hero';
import { Hero1 } from '@/components/hero1';
import { Navbar1 } from '@/components/navbar1';
import { Pricing4 } from '@/components/pricing4';

/**
 * This is the main page of the app
 * the app is a beelinguapp clone for web
 * it allows you to read articles in your language of choice and see the live translation in english
 */
export default function LandingPage() {
  return (
    <>
      <main className="flex-1 flex flex-col gap-6 px-4">
        <Navbar1 />

        <Hero1
          heading="Learn a new language by reading"
          description="Read articles in your language of choice and see the live translation in english"
          image={{
            src: 'https://shadcnblocks.com/images/block/placeholder-2.svg',
            alt: 'image here',
          }}
          buttons={{
            primary: {
              text: 'Get started',
              url: '/sign-up',
            },
          }}
          badge="✨ Your Website Builder"
        />

        <Feature16 />

        <Feature51 />

        <Pricing4 />
      </main>

      <Footer />
    </>
  );
}
